import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./contexts/AuthContext";
import { commonErrorMessages } from "./constants";
import { queryClient } from "./configs/queryClient";
import { retryPendingPushUnsubscribe } from "./lib/webPush";
import { unregisterLegacyFcmServiceWorker } from "./lib/serviceWorkerRegistration";
import "./index.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error(commonErrorMessages.rootElementNotFound);
}

// 直前の unsubscribe がブラウザ側で失敗して保留になっている場合、起動時に再試行する
void retryPendingPushUnsubscribe();

window.addEventListener('load', () => {
  void unregisterLegacyFcmServiceWorker();
});

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
